module.exports = __webpack_public_path__ + "img/nzh_pic.acbdac99.png";